/**
 * Shared client-route selection state.
 *
 * Kept outside ClientEntry/utils.js so lightweight pages can prepare client
 * navigation without importing the legacy ClientEntry module graph.
 */
export const setClientIdLocalStorage = id => {
  if (id) {
    localStorage.setItem('clientId', JSON.stringify(id));
  } else {
    localStorage.removeItem('clientId');
  }
};
